<script setup>
import SettingsSection from './SettingsSection.vue';
import AppearanceToggle from './AppearanceToggle.vue';

// Settings → Appearance. Saved on this device and applied right away, so
// there is no Save button.
</script>

<template>
  <SettingsSection
    title="Appearance settings"
    description="Choose how the app looks on this device. System follows your device's light or dark setting."
    hide-actions
  >
    <div>
      <AppearanceToggle />
    </div>
  </SettingsSection>
</template>
